import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./InitialState";
import { setCookie, deleteCookies } from "../services/cookieService";
import environment from "../constants/Environment";

const envData = environment();

export const userSlice = createSlice({
  name: "user",
  initialState: initialState.user,
  reducers: {
    setSelectedCompanyId: (state, action) => {
      state.selectedCompanyId = action.payload;
    },
    login: (state, action) => {
      state.isLoggedIn = true;
      state.userEmail = action.payload.userEmail;
      state.userName = action.payload.userName;
      state.userPhone = action.payload.userPhone;
      state.userId = action.payload.userId;
      state.hasSetPassword = action.payload.hasSetPassword;
      state.sessionCount = action.payload.sessionCount;
      state.companyDetails.logo = action.payload.companyDetails.logo;
      state.companyDetails.compName = action.payload.companyDetails.compName;
      state.companyDetails.count = action.payload.companyDetails.count;
      state.companyDetails.fromGemini =
        action.payload.companyDetails.fromGemini;
      state.companyDetails.fromMu = action.payload.companyDetails.fromMu;
      // state.companyDetails.creditId = action.payload.companyDetails.creditId;
      // state.companyDetails.isNewUser = action.payload.companyDetails.isNewUser;
      state.companyDetails.createdAt = action.payload.companyDetails.createdAt;
      state.companyDetails.subDomain = action.payload.companyDetails.subDomain;
      state.companyDetails.updatedAt = action.payload.companyDetails.updatedAt;
      state.companyDetails.userId = action.payload.companyDetails.userId;
      state.companyDetails._id = action.payload.companyDetails._id;
      state.companyDetails.defaultCustomDomain =
        action.payload.companyDetails.defaultCustomDomain;
      state.defaultCompany = action.payload.defaultCompany;
      state.showCoupon = action.payload.showCoupon;
      state.selectedCompanyId = action.payload.companyDetails._id;
      state.companyModel = action.payload.companyDetails.companyModel;
      state.byok = action.payload.companyDetails?.byok ?? false;

      if (envData.isAI) {
        setCookie(
          "cbb-userName",
          action.payload.userName,
          7,
          envData?.PAGE_DOMAIN,
          "/",
        );
        setCookie(
          "cbb-userEmail",
          action.payload.userEmail,
          7,
          envData?.PAGE_DOMAIN,
          "/",
        );
        setCookie(
          "cbb-plan",
          action.payload.companyDetails.planName,
          7,
          envData?.PAGE_DOMAIN,
          "/",
        );
      }
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.selectedCompanyId = null;
      deleteCookies("token", "/");
      deleteCookies("cbb-userName", "/");
      deleteCookies("cbb-userEmail", "/");
      deleteCookies("cbb-plan", "/");
      clearInterval(state.trainingIntervalId);
    },
    setInfoModal: (state, action) => {
      state.infoModal.showModal = action.payload.showModal;
      state.infoModal.modalType = action.payload.modalType;
      state.infoModal.modalTitle = action.payload.modalTitle;
      state.infoModal.modalMessage = action.payload.modalMessage;
      state.infoModal.modalButtonText = action.payload.modalButtonText;
      state.infoModal.showModalButton = action.payload.showModalButton;
      state.infoModal.calledFromAgent = action.payload.calledFromAgent;
    },
    setSuccessModal: (state, action) => {
      state.successModal = action.payload;
    },
    setSuccessTitle: (state, action) => {
      state.successTitle = action.payload;
    },
    setSuccessMessage: (state, action) => {
      state.successMessage = action.payload;
    },
    setErrorModal: (state, action) => {
      state.errorModal = action.payload;
    },
    setErrorTitle: (state, action) => {
      state.errorTitle = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setWarningModal: (state, action) => {
      state.errorModal = action.payload;
    },
    setWarningTitle: (state, action) => {
      state.errorTitle = action.payload;
    },
    setWarningMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setToastPopUp: (state, action) => {
      state.toast.show = action.payload.show;
      state.toast.toastType = action.payload.toastType;
      state.toast.message = action.payload.message;
      state.toast.duration = action.payload.duration;
    },
    setToast: (state, action) => {
      state.showToast = action.payload;
    },
    setToastType: (state, action) => {
      state.toastType = action.payload;
    },
    setToastMessage: (state, action) => {
      state.toastMessage = action.payload;
    },
    setReload: (state, action) => {
      state.reload = action.payload;
    },
    setDuplicatingBotId: (state, action) => {
      state.duplicatingBotId = action.payload;
    },
    setSettings: (state, action) => {
      state.settings = action.payload;
    },
    setFromBilling: (state, action) => {
      state.fromBilling = action.payload;
    },
    setShowConfiguration: (state, action) => {
      state.showConfiguration = action.payload;
    },
    setShowBotAnalytics: (state, action) => {
      state.showBotAnalytics = action.payload;
    },
    setShowSegmentEdit: (state, action) => {
      state.showSegmentEdit = action.payload;
    },
    addValue: (state, action) => {
      state.addClass = action.payload;
      // state.boolValue = !state.boolValue
    },
    closeBool: (state, action) => {
      state.boolValue = action.payload;
    },
    // setCompanyDetails: (state, action) => {
    //   state.companyDetails.compName = action.payload.compName;
    //   state.companyDetails.logo = action.payload.logo;
    //   state.companyDetails.count = action.payload.count;
    //   state.companyDetails.createdAt = action.payload.createdAt;
    //   state.companyDetails.updatedAt = action.payload.updatedAt;
    //   state.companyDetails.subDomain = action.payload.subDomain;
    //   state.companyDetails.userId = action.payload.userId;
    //   state.companyDetails._id = action.payload.id;
    // },
    setCompanyDetails: (state, action) => {
      state.companyDetails = {
        ...state.companyDetails,
        ...action.payload,
      };
      if (action.payload._id) {
        state.selectedCompanyId = action.payload._id;
      }
    },
    setCompanyName: (state, action) => {
      state.companyDetails.compName = action.payload.compName;
    },
    setSwitchLoad: (state, action) => {
      state.switchLoad = action.payload;
    },
    closeCoupon: (state, action) => {
      state.showCoupon = action.payload;
    },
    setDebug: (state, action) => {
      state.debug = action.payload;
    },
    setBeta: (state, action) => {
      state.beta = action.payload;
    },
    setPlan: (state, action) => {
      state.plan = action.payload;
    },
    setBilling: (state, action) => {
      state.billing = action.payload;
    },
    setRole: (state, action) => {
      // Commenting out access control: Treat these roles as admin to bypass UI restrictions
      if (
        action.payload === "analyst" ||
        action.payload === "user" ||
        action.payload === "manager"
      ) {
        state.role = "admin";
      } else {
        state.role = action.payload;
      }
    },
    setTrainData: (state, action) => {
      if (action.payload.interval && !state.trainingPending) {
        clearInterval(action.payload.interval);
        return;
      }

      state.trainingPending = action.payload.pending;
      state.trainingProgress = action.payload.progress;
      state.trainingBotId = action.payload.botId;
      if (action.payload.type) state.trainingType = action.payload.type;
    },
    setTrainInterval: (state, action) => {
      clearInterval(state.trainingIntervalId);
      state.trainingIntervalId = action.payload.trainingIntervalId;
    },
    clearTrainInterval: (state) => {
      clearInterval(state.trainingIntervalId);
      state.trainingIntervalId = 0;
      state.trainingPending = false;
      state.trainingProgress = 0;
      state.trainingBotId = "";
    },
    setThrive: (state, action) => {
      state.thrive = action.payload;
    },
    setThriveData: (state, action) => {
      state.thriveData.email = action.payload.email;
      state.thriveData.digest = action.payload.digest;
      state.thriveData.userId = action.payload.userId;
    },
    setSocket: (state, action) => {
      state.socket = action.payload;
    },
    setShowHelloBar: (state, action) => {
      state.showHelloBar = action.payload;
    },
    setHelloBarDelay: (state, action) => {
      state.helloBarDelay = action.payload;
    },
    setUserDetails: (state, action) => {
      state.userName = action.payload.userName;
      state.userEmail = action.payload.userEmail;
      state.userPhone = action.payload.userPhone;
    },
    setTextToWorkflowPrompt: (state, action) => {
      state.textToWorkflowPrompt = action.payload;
    },
    setDefaultCustomDomain: (state, action) => {
      state.companyDetails.defaultCustomDomain = action.payload;
    },
    updateAiUsage: (state, action) => {
      if (state.plan && state.plan.ai_currentUsage) {
        state.plan.ai_currentUsage.rateLimit = action.payload;
      }
    },
    incrementAiUsage: (state, action) => {
      if (state.plan && state.plan.ai_currentUsage) {
        state.plan.ai_currentUsage.rateLimit =
          (state.plan.ai_currentUsage.rateLimit || 0) + (action.payload || 1);
      }
    },
    setOutgrowData: (state, action) => {
      state.fromOutgrow = true;
      state.outgrowData = action.payload;
    },
    setCreditId: (state, action) => {
      state.creditId = action.payload;
    },
    setIsNewUser: (state, action) => {
      state.isNewUser = action.payload;
    },
    setByok: (state, action) => {
      state.byok = action.payload;
    },
    setCreditUsed: (state, action) => {
      state.creditUsed = action.payload;
    },
  },
});

export const { login, addValue, updateAiUsage, incrementAiUsage } =
  userSlice.actions;

const userReducer = userSlice.reducer;
export default userReducer;
